export type PostTryOnTelemetryEvent =
  | 'checkout_cta_rendered'
  | 'checkout_cta_clicked'
  | 'checkout_request_started'
  | 'checkout_request_succeeded'
  | 'checkout_request_failed'
  | 'frontend_close_attempted'
  | 'frontend_close_succeeded'
  | 'frontend_close_blocked'
  | 'frontend_return_succeeded'
  | 'frontend_return_blocked'
  | 'whatsapp_return_gesture_started'
  | 'whatsapp_deep_link_opened'
  | 'whatsapp_deep_link_blocked'
  | 'whatsapp_manual_return_clicked'
  | 'post_try_on_result_viewed'
  | 'post_try_on_product_viewed'
  | 'post_try_on_product_image_failed'
  | 'post_try_on_result_image_failed'
  | 'post_try_on_continue_clicked'
  | 'post_try_on_finalize_started'
  | 'post_try_on_finalize_succeeded'
  | 'post_try_on_finalize_failed'
  | 'post_try_on_whatsapp_return_started'
  | 'post_try_on_whatsapp_return_succeeded'
  | 'post_try_on_whatsapp_return_failed'
  | 'post_try_on_window_close_attempted'
  | 'post_try_on_window_close_blocked'
  | 'post_try_on_terminal_route_loaded'
  | 'post_try_on_session_restore_blocked'
  | 'post_try_on_duplicate_click_blocked'

function browserName(userAgent: string) {
  if (/Edg\//i.test(userAgent)) return 'Edge'
  if (/SamsungBrowser\//i.test(userAgent)) return 'Samsung Internet'
  if (/CriOS\//i.test(userAgent)) return 'Chrome iOS'
  if (/Chrome\//i.test(userAgent)) return 'Chrome'
  if (/FxiOS\//i.test(userAgent)) return 'Firefox iOS'
  if (/Firefox\//i.test(userAgent)) return 'Firefox'
  if (/Safari\//i.test(userAgent)) return 'Safari'
  return 'Unknown'
}

function operatingSystem(userAgent: string) {
  if (/Android/i.test(userAgent)) return 'Android'
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'iOS'
  if (/Windows/i.test(userAgent)) return 'Windows'
  if (/Macintosh|Mac OS X/i.test(userAgent)) return 'macOS'
  if (/Linux/i.test(userAgent)) return 'Linux'
  return 'Unknown'
}

function environmentDetail() {
  const userAgent = window.navigator.userAgent
  return {
    browser: browserName(userAgent),
    operatingSystem: operatingSystem(userAgent),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
  }
}

export function emitPostTryOnTelemetry(event: PostTryOnTelemetryEvent, detail: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('mia-every-event', { detail: { type: event, occurredAt: new Date().toISOString(), ...environmentDetail(), ...detail } }))
}
